export default "__VITE_ASSET__YvE2c20C__"